// PWA app-badge — paints a numeric badge on the installed PWA's home-screen
// icon, mirroring the unseen-Inbox count that drives the in-app Feed-tab dot.
//
// Browser support: installed PWAs on Chrome desktop, Edge, Safari iOS 16.4+.
// Silent no-op everywhere else (the try/catch swallows both `undefined` API
// access and the InvalidStateError some browsers throw when the page isn't
// installed). Never call from non-installed contexts expecting an effect.

export function setBadge(n) {
  try {
    if (typeof n === "number" && n > 0) {
      navigator.setAppBadge?.(n);
    } else {
      navigator.clearAppBadge?.();
    }
  } catch {
    /* unsupported / not installed PWA — silent */
  }
}

export function clearBadge() {
  try {
    navigator.clearAppBadge?.();
  } catch {
    /* unsupported / not installed PWA — silent */
  }
}
